import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { server } from "../server";

function Login() {
  const navigate = useNavigate();
  const [loginMethod, setLoginMethod] = useState("phone");
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload =
      loginMethod === "phone"
        ? { phone: Number(value), role: "user" }
        : { email: value, role: "user" };

    try {
      setLoading(true);
      const response = await fetch(`${server}/Auth/Login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        navigate("/verify-otp", { state: { [loginMethod]: value } });
      } else {
        alert(data.message || "Login failed");
      }
    } catch (err) {
      alert("Something went wrong, please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-login vh-100 d-flex align-items-center">
      <div className="container position-relative z-3">
        <div className="row g-0 login-bg vh-75 rounded-5 overflow-hidden">
          <div className="col-lg-4 col-md-12 d-flex align-items-center justify-content-center">
            <div className="ps-7 pe-8 mt-n3 m-2 w-100 pt-lg-0 pt-8">
              <div>
                <Link to="/">
                  <img
                    src="/assets/images/logo.png"
                    className="mb-3"
                    alt="logo-icon"
                    width="130"
                  />
                </Link>
                <div className="d-flex flex-column gap-1">
                  <h3 className="mb-0 fw-bold text-white lh-1">Sign in</h3>
                  <span className="text-light lh-1">
                    Don't have an account?
                    <Link to="/signup" className="ms-1">
                      Sign up
                    </Link>
                  </span>
                </div>

                {/* Pill Toggle */}
                <div
                  className="mt-3 d-flex rounded-pill p-1"
                  style={{
                    background: "rgba(255,255,255,0.12)",
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  {["phone", "email"].map((method) => (
                    <button
                      key={method}
                      type="button"
                      onClick={() => {
                        setLoginMethod(method);
                        setValue("");
                      }}
                      className="btn border-0 flex-fill rounded-pill py-1"
                      style={{
                        fontSize: "0.85rem",
                        fontWeight: loginMethod === method ? 600 : 400,
                        color:
                          loginMethod === method
                            ? "#000"
                            : "rgba(255,255,255,0.75)",
                        background:
                          loginMethod === method ? "#fff" : "transparent",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {method === "phone" ? (
                        <>
                          <i className="bi bi-telephone-fill me-1"></i> Phone
                        </>
                      ) : (
                        <>
                          <i className="bi bi-envelope-fill me-1"></i> Email
                        </>
                      )}
                    </button>
                  ))}
                </div>

                <form className="needs-validation mt-3" onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="label-text text-light opacity-75 mb-1 ms-3">
                      {loginMethod === "phone" ? "Phone No" : "Email Address"}{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type={loginMethod === "phone" ? "tel" : "email"}
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      className="form-control ps-3 normal-text text-white bg-transparent light-border rounded-3"
                      placeholder={
                        loginMethod === "phone"
                          ? "Enter Phone No"
                          : "Enter Email Address"
                      }
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="btn btn-gradient-bg-2 border-0 text-white rounded-3 px-6 btn-md w-100"
                  >
                    {loading ? (
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                      ></div>
                    ) : (
                      "Continue"
                    )}
                  </button>
                </form>

                <div className="mt-3 text-center">
                  <Link to="/contact" className="fs-5 lh-1">
                    Need Help ? Contact Us
                  </Link>
                </div>

                <div className="mt-5 d-flex justify-content-center gap-2 pb-7">
                  <img src="/assets/images/btn-appstore.svg" width="145" />
                  <img src="/assets/images/btn-g-play.svg" width="145" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-12">
            <img
              src="/assets/images/1.jpg"
              className="w-100 h-100 object-fit-cover rounded-end-5"
              alt="login"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
